export default __webpack_public_path__ + "static/media/pkb-9.9475bf53.png";